<template>
    <transition name="modal">
        <div id="ajoutJeu" class="modal-wrapper">
            <b-card class="modal-container">              
                <h2 class="mt-3 mb-3">Ajouter un jeu de Requête</h2>
                <div>
                    <b-card class=" formAjout mr-4 ml-4">
                        <form @submit.prevent="emitInsertJeuRequete" id="validAdd">

                            <b-form-group class="labelTitre" id="input-group-1" label="Nom:" label-for="input-1">
                              <Field name="nom" type="text" placeholder="renseigner le nom du jeu" class="form-control" />
                              <ErrorMessage name="nom" class="text-danger" />
                            </b-form-group>

                            <b-form-group class="labelTitre" id="input-group-2" label="Description:" label-for="textarea-large">
                              <Field name="description" as="textarea"  class="form-control" />
                              <ErrorMessage name="description" class="text-danger" />
                            </b-form-group>

                        <b-col md="6">
                            <b-form-group class = "labelTitre" id="input-group-3" label="Schéma:" label-for="input-3">
                                <b-form-select id="input-3" v-model="schema.idSchema">
                                    <option v-for="s in schemas" v-bind:value="s.idSchema" v-bind:key="s.idSchema">{{s.nom}}</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                          <b-button pill type="submit" class="nav-link3 m-2">Valider</b-button>
                          <b-button pill class="nav-link2 m-2" id="close" @click="$emit('close')">Annuler</b-button>
                        </form>
                    </b-card>
                </div>
            </b-card>
        </div>        
    </transition>    
</template>

<script>

import { Field, ErrorMessage } from 'vee-validate';
import useAjoutJeuRequetes from "@/composition/JeuRequetes/addJeu";


export default {
    name:"ModalAddJeu",

  components:{
    Field,
    ErrorMessage,
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(_, { emit }){
    return useAjoutJeuRequetes({emit});
  }
}
</script>

<style>
.labelTitre{
  text-align: left !important;
}
.formAjout{
  background-color: #c0c0c0;
}

.modal-wrapper {
  vertical-align: middle;
}

.modal-container {
  background-color: white;
  width: 80%;
  margin: 0px auto;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
